module.exports = __webpack_public_path__ + "static/img/1029.804918c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1029.jpg
// module id = Q8LB
// module chunks = 1